import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Table from '../../../core-components/theme/components/Table/Table';
import { BatchConfigTableColumns } from '../helpers/BatchConfigTableColumns';
import { useBatchConfigTable } from '../hooks/useBatchConfigTable';
import { useState } from 'react';
interface BatchConfigTableProps {
  searchString: string;
  assetId: string;
  isPending?: boolean;
  onRowClick: (batchId: string) => void
}

export default function BatchConfigTable({
  searchString,
  isPending,
  onRowClick,
  assetId,
}: BatchConfigTableProps) {
  const {
    batches = [],
    lastElementRef,
    tableContainerRef,
  } = useBatchConfigTable(searchString, assetId);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number>(-1);
  const navigate = useNavigate();


  const handleRowClick = (rowIndex: number) => {
    const id = batches[rowIndex]?.batchId || '';
    setSelectedRowIndex(prev => (prev === rowIndex ? -1 : rowIndex));
    onRowClick(id);
  };

  return (
    <Box
      ref={tableContainerRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: { xs: '76vh', md: '70vh' },
        opacity: isPending ? '0.3' : '1',
      }}
    >
      <Table
        stickyHeader
        rows={batches}
        columns={BatchConfigTableColumns(navigate)}
        lastRowRef={lastElementRef}
        onRowSelect={handleRowClick}
        selectedRow={selectedRowIndex}
      />
    </Box>
  );
}
